<template>
  <div class="carousel-wrapper">
    <div class="slider">
      <div
        class="track"
        :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
      >
        <img
          v-for="(photo, index) in imageList"
          :key="index"
          class="slide"
          alt=""
          loading="lazy"
          :src="photo"
        />
      </div>
    </div>

    <template v-if="imageList.length > 1">
      <!-- left -->
      <button
        class="nav left"
        @click.stop="prev"
      >
        <img
          src="@/assets/icons/icon_arrow-left.svg"
          alt=""
          class="nav-icon"
        >
      </button>
      <!-- right -->
      <button
        class="nav right"
        @click.stop="next"
      >
        <img
          src="@/assets/icons/icon_arrow-right.svg"
          alt=""
          class="nav-icon">
      </button>

      <!-- dots -->
      <div
        class="dots"
        @click.stop
      >
        <span
          v-for="(_, index) in imageList"
          :key="index"
          class="dot"
          :class="bindCarouselBulletClassName(currentIndex, index)"
          @click="goTo(index)"
        />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ImageCarousel',
  props: {
    imageList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentIndex: 0
    }
  },
  methods: {
    next () {
      this.currentIndex++

      const lastImageIndex = this.imageList.length - 1
      if (this.currentIndex > lastImageIndex) {
        this.currentIndex = 0
      }
    },
    prev () {
      this.currentIndex--

      const lastImageIndex = this.imageList.length - 1
      if (this.currentIndex < 0) {
        this.currentIndex = lastImageIndex
      }
    },
    goTo (index) {
      this.currentIndex = index
    },
    bindCarouselBulletClassName (currentIndex, index) {
      const total = this.imageList.length
      const diff = Math.abs(index - currentIndex)

      const isNearAction = (diff <= 2)
      const isNearStart = (currentIndex <= 2)
      const isNearEnd = (currentIndex >= (total - 3))

      const isVisibleAtStart = isNearStart && (index <= 4)
      const isVisibleAtEnd = isNearEnd && (index >= (total - 6))

      const isMiddle = !isNearStart && !isNearEnd && (diff === 3)
      const isStart = isNearStart && (index === 5)
      const isEnd = isNearEnd && (index === (total - 6))

      const isVisible = isNearAction || isVisibleAtStart || isVisibleAtEnd
      const isEdgeDot = isMiddle || isStart || isEnd

      return {
        'active': (index === currentIndex),
        'visible': isVisible,
        'edge-dot': isEdgeDot
      }
    }
  }
}
</script>

<style scoped>
.carousel-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.slider {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.track {
  display: flex;
  height: 100%;
  transition: transform 0.4s ease;
}

.slide {
  flex: 0 0 100%;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #0000007F;
  color: #fff;
  display: grid;
  place-items: center;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.nav.left {
  left: 8px;
}

.nav.right {
  right: 8px;
}

.nav .nav-icon {
  width: 18px;
  height: 18px
}

.dots {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 5px;
  gap: 6px;
  border-radius: 25px;
  background-color: #0000007F;
}

.dot {
  position: relative;
  display: none;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #FFFFFF;
  opacity: 0.5;
}

.dot:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 15px;
  pointer-events: fill;
  cursor: pointer;
}

.dot.visible {
  display: block;
}

.dot.active {
  display: block;
  background-color: #FFFFFF;
  opacity: 1;
  transition: all 0.5s ease;
}

.dot.edge-dot {
  display: block;
  width: 4px;
  height: 4px;
  transition: all 0.8s ease;
}
</style>
